export default (element) => typeof element === 'function';
